import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import React, { Fragment } from 'react';
import { styled } from 'linaria/react';
import {
  ProductSection as UIProductSection,
  SectionHeading
} from './ProductInfo';

import { theme } from '../Theme';

const ProductSection = styled(UIProductSection)`
  border-bottom: 1px solid #eaeaea;
  padding: 0.5rem 0;
  margin: 0;
  font-size: 0.875rem;
  width: 100%;
  :first-of-type {
    border-top: 1px solid #eaeaea;
  }
  :last-of-type {
    margin-bottom: 2rem;
    ${theme.below.md} {
      margin-bottom: 4rem;
    }
  }
  ${SectionHeading} {
    display: flex;
    color: black;
    cursor: pointer;
    justify-items: space-between;
    align-items: center;
    margin-bottom: 0;
    padding-bottom: 0.75rem;
    ${theme.below.md} {
      padding-top: 1rem;
      padding-bottom: 0;
    }
  }
`;

const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
`;
const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>{isOpen ? '-' : '+'}</IndicatorIcon>
);

const ProductInfoAccordion = ({ product }) => {
  const { customFields = [] } = product;

  const sizeGuide = customFields?.find(({ key }) => key === 'size-guide');
  const washingInstructions = customFields?.find(
    ({ key }) => key === 'washing-instructions'
  );

  return (
    <>
      <Accordion single>
        {({ openIndexes, handleClick, AccordionContent }) => (
          <Fragment>
            {sizeGuide?.htmlValue?.length > 0 && (
              <ProductSection>
                <SectionHeading onClick={() => handleClick(0)}>
                  <span>{t('Size guide')}</span>
                  <AccordionIndicator isOpen={openIndexes.includes(0)} />
                </SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(0)}>
                  <span
                    dangerouslySetInnerHTML={{ __html: sizeGuide.htmlValue }}
                  />
                </AccordionContent>
              </ProductSection>
            )}
            {washingInstructions?.htmlValue?.length > 0 && (
              <ProductSection>
                <SectionHeading onClick={() => handleClick(1)}>
                  <span>{t('Washing instructions')}</span>
                  <AccordionIndicator isOpen={openIndexes.includes(1)} />
                </SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(1)}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: washingInstructions.htmlValue
                    }}
                  />
                </AccordionContent>
              </ProductSection>
            )}
          </Fragment>
        )}
      </Accordion>
    </>
  );
};

export default ProductInfoAccordion;
